export default {
      id: "loader-spinner-usage",
      viewBox: "0 0 96 96",
      url: __webpack_public_path__ + "icons-sprite.626747e.svg#loader-spinner-usage",
      toString: function () {
        return this.url;
      }
    }